<template>
  <div class="leads">
    <gnetHeader></gnetHeader>

    <gnetTabBar
      v-bind:titoloapp="$store.getters.appname"
      v-bind:tabs="$store.state.tabs"
      v-bind:active_tab="$store.state.active_tab"
      v-on:click="changeTab($event)"
    />
    <gnetTable
      v-bind:cols="cols"
      v-bind:records="records"
      v-on:click="gotoRecord($event)"
      v-on:filter="filter($event)"
    >      
    </gnetTable>

    <gnetModal
      v-if="filterPanel.show"
      v-bind:title="'Applica filtro'"
      v-bind:object="'lead'"
      v-on:cancel="filterPanel.show=false"
      v-on:submit="doFilter"
    >
        <label class="slds-form-element__label" v-bind:for="'form-element-1'">{{filterPanel.name}}</label>

        <div class="slds-form-element__control">
          <input v-model="filterPanel.value" type="text" id="form-element-2" placeholder="filtro..." class="slds-input" />
        </div>
    </gnetModal>

  </div>
</template>

<script>
// @ is an alias to /src
// import numeral from 'numeral'
import gnetHeader from '../components/header.vue'
import gnetTabBar from '../components/tabbar.vue'
import gnetTable from '../components/table.vue'
import gnetModal from '../components/modal.vue'
import apiclient from '@/apiclient.js'
import gnetMixLib from '@/mixin.js'

export default {
  name: 'Leads',
  mixins: [gnetMixLib],
  components: {
    gnetHeader,
    gnetTabBar,
    gnetTable,
    gnetModal
  },
  computed: {
    actualdealer: function() {
      if (this.$store.state.multizona) 
        return this.$store.getters.zona;
      else
        return '';
    }
  },
  watch: {
    actualdealer: function() {
      this.getRecords();
    }
  },
  data: function() {
    return {
        cols: [],
        records: [],
        fieldsstring: '',
        filterPanel: {
          show: false,
          value:'',
          name:'',
          index:0,
          filterCol: {}
        }
    };
  },
  mounted: function() {
    this.setupRecordFields();
    this.getRecords();
  },
  methods: {
    doFilter: function() {
      var col=this.cols[this.filterPanel.index];
      col.filtered=this.filterPanel.value;
      this.filterPanel.show=false;
      this.getRecords();
    },
    filter: function(index) {
      console.log('filtertt');
      var col=this.cols[index];
      if (col.filtered) {
        col.filtered=false;
        col.filterValue='';
        this.getRecords();
      } else {
        this.filterPanel.index=index;
        this.filterPanel.name=col.label;
        this.filterPanel.filterCol=col;
        this.filterPanel.value='';
        this.filterPanel.show=true;
      }
    },
    getRecords: function() {
      var self=this;
      var filtri=[];
      this.cols.forEach(function(d){
        if (d.filtered)
          filtri.push(d.name+'=\''+d.filtered+'\'');
      });
      var soql='select '+this.fieldsstring+' from Account';

      filtri.push('tipoAccount__c=\'Lead\'');
      filtri.push('Zona_1__c=\''+this.$store.getters.zona+'\'');

      var swhere=' where '+filtri.join(' and ');
      if (filtri.length>0)
        soql=soql+swhere;
      soql+=' order by name asc limit 300';
      console.log(soql);
      apiclient.query(this.$store.getters.connection, soql).then(function(data) {
        console.log('records:'+data.length);
        self.records=data;
      }).catch(function(err){
        console.log(err);
      })
    },
    gotoRecord: function(record) {
      console.log(record);
      this.$router.push({ name:'LeadForm', params: { id: record.Id, record: record } });
    },
    setupRecordFields: function() {
      // Protocollo, fase, funzionario, assistente, CST, data apertura mandato
      var ord=1;
//      this.cols.push( { order: ord++, value:'', label:'Prot.', name:'Name', type:'string' } );
      this.cols.push( { order: ord++, value:'', label:'Ragione Sociale', name:'Name', type:'truncate' } );
      this.cols.push( { order: ord++, value:'', label:'Indirizzo', name:'BillingStreet', type:'truncate' } );
      this.cols.push( { order: ord++, value:'', label:'Città', name:'BillingCity', type:'string' } );
      this.cols.push( { order: ord++, value:'', label:'Creato il', name:'CreatedDate', type:'date' } );
      this.cols.push( { order: ord++, value:'', label:'Info', name:'alert__c', type:'alert' } );
      this.cols.push( { order: ord++, value:'', label:'Ultima Attività', name:'LastActivityDate', type:'date' } );

      var mfields=new Map();
      mfields.set('Id', null);
      this.mapFields(mfields, this.cols);
      this.fieldsstring=this.uniqueFields(mfields).join(',');

    }
  }
}
</script>
